import { render, staticRenderFns } from "./InterestFollowUpTable.vue?vue&type=template&id=40b6bbc4&"
import script from "./InterestFollowUpTable.vue?vue&type=script&lang=js&"
export * from "./InterestFollowUpTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports